import React from 'react';
import styles from './NumberField.module.scss';
import { joinClasses } from '../../../../../../Utils/className.util';

interface Props {
	name: string;
	isRequired?: boolean;
	placeholder?: string;
	value?: string;
	onChange?: (value: string) => void;
	suffix?: string;
	netteRules?: string;
}

const NumberField: React.FC<Props> = ({
	name,
	isRequired,
	value,
	onChange,
	placeholder,
	suffix,
	netteRules,
}) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		// @ts-ignore
		const value = event.target.value.replace(',', '.');
		onChange?.(value);
	};

	return (
		<div className={styles.wrapper}>
			<input
				type='number'
				name={name}
				required={isRequired}
				defaultValue={value}
				placeholder={placeholder}
				className={joinClasses([styles.input, suffix ? styles.withSuffix : ''])}
				onChange={handleChange}
				data-nette-rules={netteRules}
				step='.1'
			/>
			{suffix && <div className={styles.unit}>{suffix}</div>}
		</div>
	);
};

export default NumberField;
